__turbopack_context__.v({
  "col": "DoubleCard-module-scss-module__fJZ7cW__col",
  "col2": "DoubleCard-module-scss-module__fJZ7cW__col2",
  "col3": "DoubleCard-module-scss-module__fJZ7cW__col3",
  "col4": "DoubleCard-module-scss-module__fJZ7cW__col4",
  "fullHeight": "DoubleCard-module-scss-module__fJZ7cW__fullHeight",
  "nestedProductCard": "DoubleCard-module-scss-module__fJZ7cW__nestedProductCard",
  "nestedProductCta": "DoubleCard-module-scss-module__fJZ7cW__nestedProductCta",
  "nestedProductHeading": "DoubleCard-module-scss-module__fJZ7cW__nestedProductHeading",
  "nestedProductTile": "DoubleCard-module-scss-module__fJZ7cW__nestedProductTile",
  "wrapper": "DoubleCard-module-scss-module__fJZ7cW__wrapper",
});
